import { useEffect } from 'react';
import { ANALYTICS_CONSENT_KEY } from '../privacy/CookieConsent';
type ConversionName = 'sdk_inquiry_click' | 'article_original_click' | 'ci_download' | 'contact_submit_success' | 'application_submit_success';
export function trackConversion(name: ConversionName) {
  // No form values, article text, email addresses or URL queries are collected.
  if (import.meta.env.VITE_REVIEW_MODE === 'true') return;
  try {
    if (window.localStorage.getItem(ANALYTICS_CONSENT_KEY) !== 'granted') return;
    window.gtag?.('event', name, {page_path: window.location.pathname});
  } catch { /* Analytics must never interrupt the user journey. */ }
}
export default function ConversionEvents() {
  useEffect(() => {
    const click = (event: MouseEvent) => {
      const link = event.target instanceof Element ? event.target.closest('a') : null;
      if (!link) return;
      const url = new URL(link.href, window.location.origin);
      if (window.location.pathname.includes('/about/ci') && link.hasAttribute('download')) trackConversion('ci_download');
      else if (window.location.pathname.includes('/news/articles') && url.origin !== window.location.origin && url.protocol === 'https:') trackConversion('article_original_click');
      else if (window.location.pathname.includes('/solutions/physiolink-sdk') && /\/contacts\/?$/.test(url.pathname)) trackConversion('sdk_inquiry_click');
    };
    document.addEventListener('click', click);
    return () => document.removeEventListener('click', click);
  }, []);
  return null;
}
